module.exports = __webpack_public_path__ + "static/media/11.5e1695a6.png";